import { render, staticRenderFns } from "./addMenu.vue?vue&type=template&id=bf6bacd4&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"
import style0 from "./addMenu.vue?vue&type=style&index=0&id=bf6bacd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6bacd4",
  null
  
)

export default component.exports